// @ts-nocheck
import { PRIMARY_COLOR } from "contexts/SettingsContext";
import GenericBanner from "./GenericBanner";

// ----------------------------------------------------------------------

type RecommendationBannerProps = {
  title: string;
  content: JSX;
};

export default function RecommendationBanner({ title, content }: RecommendationBannerProps) {
  const purpleTheme = PRIMARY_COLOR.find((c) => c.name === "purple");
  return (
    <GenericBanner
      title={"💡" + title}
      content={content}
      backgroundColor={purpleTheme.lighter}
      titleTextColor={purpleTheme.darker}
      bodyTextColor={purpleTheme.dark}
    />
  );
}
